import React from 'react';
import './Advantagpallets.css';


const Advantagpallets = () => {
    return (
        <div className="Advantagpall-container">
            <div className='Ordinarys'>
                <h2 className="Advantagpall-title">The following are the advantages of plastic pallets:</h2>
                <div className="Advantagpall-content">
                    <ul className="Advantagpall-text">
                        <li>Durability: Plastic pallets last about 10 times longer than wooden pallets.</li>
                        <li>Reliability: The reliability of the plastic pallet structure greatly reduces the damage consumption of
                            the pallet, as well as the damage to the materials on the pallet due to the pallet damage.
                            The plastic pallet is lighter in weight than the same wooden pallet,
                            so it reduces the weight and cost of transportation.</li>
                        <li>Hygiene: The plastic pallet can be cleaned and reused.
                            If the cargo carried leaks, it will not pollute the plastic pallet.</li>
                        <li>Specificity: Plastic pallets will become more and more popular in
                            the special commodity market. For example, food, beverage, and pharmaceutical
                            industry, and according to the requirements of different factories,
                            plastic pallets can be made in various colors,
                            plus the corresponding company logos and marks.</li>
                        <li>Environmental protection: Plastic pallets are environmentally
                            friendly products because they can all be recycled and reused,
                            which greatly reduces waste and disposal costs.</li>
                    </ul>
                    <p className="Advantagpall-text">Disha two-platen injection molding machines are
                        widely used in logistics, the warehousing industry, producing plastic pallets,
                        turnover boxes, etc. Powerjet plastic
                        pallet injection molding machine is a good choice for you!</p>
                </div>
            </div>
        </div>
    );
};
export default Advantagpallets;
